module.exports = __webpack_public_path__ + "fonts/Blogger Sans.3b8e8e07.ttf";